export default {
    name: "NoteList",
    props: ['notes'],
    data() {
        return {}
    },
    methods: {

        showItem(name) {
            this.$emit('choseNote', {id: name});
        },

        parseDate(date) {
            let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            let format = new Date(date);
            let dateNum = format.getDate();
            let dateMonthNum = format.getMonth();
            let dateYear = format.getFullYear();

            return months[dateMonthNum] + ' ' + dateNum + ', ' + dateYear;
        }
    }

}